import { Outlet } from "react-router";

const AdminDevice = () => {
	return <Outlet />;
};

export default AdminDevice;
